import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "../Page/HomePage";
import ServicesPage from "../Page/ServicesPage";
import AboutPage from "../Page/AboutPage";
import PastPerformancePage from "../Page/PastPerformancePage";
import CapabilityPage from "../Page/CapabilityPage";
import ContactPage from "../Page/ContactPage";

const AppRoutes: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/past-performance" element={<PastPerformancePage />} />
        <Route path="/capabilities" element={<CapabilityPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
